(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bd-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initWanfuanHome = () => {
      const root = document.querySelector('.wf-home[data-wf-home-animate="true"]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!root || reduceMotion || !('IntersectionObserver' in window)) return;

      const revealTargets = root.querySelectorAll('.wf-stats, .wf-section, .wf-projects, .wf-bottom');
      root.classList.add('wf-animate-ready');

      const animateNumber = (node) => {
        const original = node.textContent.trim();
        const match = original.match(/^(\d+)(.*)$/);

        if (!match || node.dataset.wfCounted === 'true') return;

        node.dataset.wfCounted = 'true';

        const target = Number(match[1]);
        const suffix = match[2] || '';
        const duration = 980;
        const start = performance.now();

        const tick = (now) => {
          const progress = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          node.textContent = `${Math.round(target * eased)}${suffix}`;

          if (progress < 1) {
            requestAnimationFrame(tick);
          } else {
            node.textContent = original;
          }
        };

        requestAnimationFrame(tick);
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');

          if (entry.target.classList.contains('wf-stats')) {
            entry.target.querySelectorAll('.wf-stat strong').forEach(animateNumber);
          }

          observer.unobserve(entry.target);
        });
      }, { threshold: 0.18 });

      revealTargets.forEach((target) => observer.observe(target));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initWanfuanHome, { once: true });
    } else {
      initWanfuanHome();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-wf-collection-search]');
    if (!root) return;

    const form = root.querySelector('[data-wf-collection-search-form]');
    const input = root.querySelector('[data-wf-collection-search-input]');
    const suggestions = root.querySelector('[data-wf-collection-search-suggestions]');
    const correction = root.querySelector('[data-wf-collection-search-correction]');
    const count = root.querySelector('[data-wf-collection-search-count]');
    const cards = Array.from(document.querySelectorAll('[data-wf-product-card]'));
    const hotTerms = (root.dataset.hotTerms || '').split(',').map((term) => term.trim()).filter(Boolean);
    const didYouMeanPrefix = root.dataset.didYouMean || '';
    const filterLabel = root.dataset.filterLabel || '';
    const productsShownLabel = root.dataset.productsShown || '';

    const distance = (a, b) => {
      a = (a || '').toLowerCase().trim();
      b = (b || '').toLowerCase().trim();
      if (!a || !b) return 99;
      const matrix = Array.from({ length: b.length + 1 }, (_, i) => [i]);
      for (let j = 0; j <= a.length; j += 1) matrix[0][j] = j;
      for (let i = 1; i <= b.length; i += 1) {
        for (let j = 1; j <= a.length; j += 1) {
          matrix[i][j] = b[i - 1] === a[j - 1]
            ? matrix[i - 1][j - 1]
            : Math.min(matrix[i - 1][j - 1] + 1, matrix[i][j - 1] + 1, matrix[i - 1][j] + 1);
        }
      }
      return matrix[b.length][a.length];
    };

    const normalize = (value) => (value || '').toLowerCase().trim();

    const renderCorrection = (query) => {
      const match = hotTerms
        .map((term) => ({ term, score: distance(query, term) }))
        .filter((item) => item.score > 0 && item.score <= 3)
        .sort((a, b) => a.score - b.score)[0];

      if (!match || query.length < 3) {
        correction.hidden = true;
        correction.innerHTML = '';
        return;
      }

      correction.innerHTML = `${didYouMeanPrefix} <a href="#" data-wf-correction-term="${match.term}">${match.term}</a>?`;
      correction.hidden = false;
    };

    const matchingCards = (query) => {
      const value = normalize(query);
      if (!value) return cards;
      const words = value.split(/\s+/).filter(Boolean);
      return cards.filter((card) => {
        const text = normalize(card.dataset.searchText);
        return words.every((word) => text.includes(word));
      });
    };

    const renderSuggestions = (query) => {
      const value = normalize(query);
      if (value.length < 2) {
        suggestions.hidden = true;
        suggestions.innerHTML = '';
        return;
      }

      const matches = matchingCards(value).slice(0, 5);
      if (!matches.length) {
        suggestions.hidden = true;
        suggestions.innerHTML = '';
        return;
      }

      suggestions.innerHTML = matches.map((card) => {
        const title = card.dataset.productTitle || '';
        const image = card.querySelector('.wf-product-list-card__image');
        const imageHtml = image
          ? `<img src="${image.currentSrc || image.src}" alt="${title.replace(/"/g, '&quot;')}" loading="lazy">`
          : '<span class="wf-collection-search__suggest-placeholder"></span>';
        return `<a href="#" data-wf-suggestion-term="${title.replace(/"/g, '&quot;')}">${imageHtml}<span><strong>${title}</strong><small>${filterLabel}</small></span></a>`;
      }).join('');
      suggestions.hidden = false;
    };

    const filterProducts = (query) => {
      const value = normalize(query);
      const matches = matchingCards(value);
      cards.forEach((card) => {
        card.classList.toggle('is-filter-hidden', value && !matches.includes(card));
      });

      if (!value) {
        count.hidden = true;
        count.textContent = '';
        return;
      }

      count.textContent = `${matches.length} ${productsShownLabel}`;
      count.hidden = false;
    };

    const applyTerm = (term) => {
      input.value = term;
      renderCorrection(term);
      renderSuggestions(term);
      filterProducts(term);
      input.focus();
    };

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const query = input.value.trim();
      renderCorrection(query);
      renderSuggestions(query);
      filterProducts(query);
    });

    input.addEventListener('input', () => {
      const query = input.value.trim();
      renderCorrection(query);
      renderSuggestions(query);
      filterProducts(query);
    });

    root.addEventListener('click', (event) => {
      const termButton = event.target.closest('[data-wf-search-term]');
      const suggestion = event.target.closest('[data-wf-suggestion-term]');
      const correctionLink = event.target.closest('[data-wf-correction-term]');
      const target = termButton || suggestion || correctionLink;
      if (!target) return;

      event.preventDefault();
      applyTerm(target.dataset.wfSearchTerm || target.dataset.wfSuggestionTerm || target.dataset.wfCorrectionTerm);
      if (suggestion) {
        suggestions.hidden = true;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-page"]) return;
  try {
    
  (() => {
    try {
      const toast = document.querySelector('[data-contact-toast]')
      if (toast) {
        const dismissToast = () => {
          toast.classList.remove('is-visible')
          window.setTimeout(() => toast.remove(), 200)
        }

        window.requestAnimationFrame(() => toast.classList.add('is-visible'))
        toast.querySelector('[data-contact-toast-close]')?.addEventListener('click', dismissToast)
        window.setTimeout(dismissToast, 6000)
      }

      const params = new URLSearchParams(window.location.search)
      const product = params.get('product')
      const sku = params.get('sku')
      const handle = params.get('handle')
      const collection = params.get('collection')
      const collectionHandle = params.get('collection_handle')
      const items = params.get('items')
      const bodyField = document.getElementById('ContactFormBody')
      if (!product && !sku && !handle && !collection && !items) return

      const lines = []
      if (product) lines.push(`Product: ${product}`)
      if (sku) lines.push(`SKU: ${sku}`)
      if (handle) lines.push(`Product URL: /products/${handle}`)
      if (collection) lines.push(`Collection: ${collection}`)
      if (collectionHandle) lines.push(`Collection URL: /collections/${collectionHandle}`)
      if (items) {
        lines.push('Cart items:')
        items.split('||').forEach((line) => {
          const trimmed = line.trim()
          if (trimmed) lines.push(`- ${trimmed}`)
        })
      }
      lines.push('')
      lines.push('Requirement:')

      if (bodyField && !bodyField.value.trim()) {
        bodyField.value = lines.join('\n')
      }

    } catch (error) {
      console.error('Failed to prefill contact form from quote link', error)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initWanfuanHome = () => {
      const enableRoot = document.querySelector('.wf-home[data-wf-home-animate="true"]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!enableRoot || reduceMotion || !('IntersectionObserver' in window)) return;

      document.querySelectorAll('.wf-home').forEach((root) => {
        root.classList.add('wf-animate-ready');
      });

      const revealTargets = document.querySelectorAll('.wf-stats, .wf-section, .wf-bottom, .wf-cta');

      const animateNumber = (node) => {
        const original = node.textContent.trim();
        const match = original.match(/^(\d+)(.*)$/);

        if (!match || node.dataset.wfCounted === 'true') return;

        node.dataset.wfCounted = 'true';

        const target = Number(match[1]);
        const suffix = match[2] || '';
        const duration = 980;
        const start = performance.now();

        const tick = (now) => {
          const progress = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          node.textContent = `${Math.round(target * eased)}${suffix}`;

          if (progress < 1) {
            requestAnimationFrame(tick);
          } else {
            node.textContent = original;
          }
        };

        requestAnimationFrame(tick);
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');

          if (entry.target.classList.contains('wf-stats')) {
            entry.target.querySelectorAll('.wf-stat strong').forEach(animateNumber);
          }

          observer.unobserve(entry.target);
        });
      }, { threshold: 0.18 });

      revealTargets.forEach((target) => observer.observe(target));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initWanfuanHome, { once: true });
    } else {
      initWanfuanHome();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-inquiry"] && !Shopify.designMode) return;
  try {
    
  (() => {
    try {
      const params = new URLSearchParams(window.location.search)
      const product = params.get('product')
      const sku = params.get('sku')
      const handle = params.get('handle')
      const collection = params.get('collection')
      const items = params.get('items')
      const bodyField = document.getElementById('HomeInquiryBody')

      if (!bodyField || (!product && !sku && !handle && !collection && !items)) return
      if (bodyField.value.trim()) return

      const lines = []
      if (product) lines.push(`Product: ${product}`)
      if (sku) lines.push(`SKU: ${sku}`)
      if (handle) lines.push(`Product URL: /products/${handle}`)
      if (collection) lines.push(`Collection: ${collection}`)
      if (items) {
        lines.push('Cart items:')
        items.split('||').forEach((line) => {
          const trimmed = line.trim()
          if (trimmed) lines.push(`- ${trimmed}`)
        })
      }
      lines.push('')
      lines.push('Requirement:')
      bodyField.value = lines.join('\n')
    } catch (error) {
      console.error('Failed to prefill home inquiry form', error)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const markClampedTitles = () => {
      document.querySelectorAll('.wf-product-card__title-text').forEach((el) => {
        if (el.scrollHeight > el.clientHeight + 1) {
          el.closest('.wf-product-card')?.classList.add('is-clamped');
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', markClampedTitles, { once: true });
    } else {
      markClampedTitles();
    }
    window.addEventListener('load', markClampedTitles);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const setHeroImage = (heroImage, { src, srcset, fullSrc, imageId }) => {
      if (!heroImage || !src) return

      try {
        heroImage.src = src
        if (srcset) {
          heroImage.srcset = srcset
        }
        if (fullSrc) {
          heroImage.dataset.fullSrc = fullSrc
        }
        if (imageId) {
          heroImage.dataset.imageId = imageId
        }
      } catch (error) {
        console.error('Failed to update hero image', error)
      }
    }

    const setActiveThumb = (thumbs, imageId) => {
      thumbs.forEach((thumb) => {
        const isActive = Boolean(imageId) && thumb.dataset.imageId === String(imageId)
        thumb.classList.toggle('is-active', isActive)
        thumb.setAttribute('aria-pressed', isActive ? 'true' : 'false')
      })
    }

    const initGallery = () => {
      try {
        const gallery = document.querySelector('[data-product-gallery]')
        if (!gallery) return

        const heroImage = gallery.querySelector('[data-gallery-hero]')
        const openBtn = gallery.querySelector('[data-gallery-open]')
        const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'))
        let lightbox =
          document.querySelector('[data-gallery-lightbox]') ||
          gallery.closest('.industrial-product')?.querySelector('[data-gallery-lightbox]')
        if (!heroImage) return

        // Move lightbox to body so position:fixed covers the full viewport
        // (avoids ancestor overflow/transform trapping the overlay in the media column).
        if (lightbox && lightbox.parentElement !== document.body) {
          document.body.appendChild(lightbox)
        }

        const lightboxImage = lightbox ? lightbox.querySelector('[data-gallery-lightbox-image]') : null
        const closeBtn = lightbox ? lightbox.querySelector('[data-gallery-close]') : null
        const prevBtn = lightbox ? lightbox.querySelector('[data-gallery-prev]') : null
        const nextBtn = lightbox ? lightbox.querySelector('[data-gallery-next]') : null

        let activeIndex = Math.max(
          0,
          thumbs.findIndex((thumb) => thumb.dataset.imageId === heroImage.dataset.imageId)
        )
        let lastFocused = null
        let isLightboxOpen = false

        const clearStaleScrollLocks = () => {
          try {
            document.documentElement.classList.remove('industrial-product-lightbox-open')
            document.documentElement.style.removeProperty('overflow')
            document.body.style.removeProperty('overflow')
            document.body.style.removeProperty('position')
            document.body.style.removeProperty('top')
            document.body.style.removeProperty('width')
            document.body.style.removeProperty('left')
            document.body.style.removeProperty('right')
          } catch (error) {
            console.error('Failed to clear lightbox scroll locks', error)
          }
        }

        // Remove leftover locks from older script versions / hot reload.
        clearStaleScrollLocks()

        const applyThumb = (thumb, { syncLightbox = false } = {}) => {
          if (!thumb) return

          setHeroImage(heroImage, {
            src: thumb.dataset.src,
            srcset: thumb.dataset.srcset,
            fullSrc: thumb.dataset.fullSrc,
            imageId: thumb.dataset.imageId
          })
          setActiveThumb(thumbs, thumb.dataset.imageId)
          activeIndex = thumbs.indexOf(thumb)

          if (syncLightbox && isLightboxOpen && lightboxImage) {
            lightboxImage.src = thumb.dataset.fullSrc || thumb.dataset.src || ''
            lightboxImage.alt = heroImage.alt || ''
          }
        }

        const openLightboxView = () => {
          if (!lightbox || !lightboxImage) return

          try {
            lastFocused = document.activeElement
            lightboxImage.src = heroImage.dataset.fullSrc || heroImage.currentSrc || heroImage.src
            lightboxImage.alt = heroImage.alt || ''
            lightbox.hidden = false
            lightbox.scrollTop = 0
            isLightboxOpen = true
            clearStaleScrollLocks()
            if (closeBtn) closeBtn.focus({ preventScroll: true })
          } catch (error) {
            console.error('Failed to open product lightbox', error)
            isLightboxOpen = false
            clearStaleScrollLocks()
          }
        }

        const closeLightboxView = () => {
          if (!lightbox) return

          try {
            lightbox.hidden = true
            if (lightboxImage) lightboxImage.removeAttribute('src')
            isLightboxOpen = false
            clearStaleScrollLocks()

            if (lastFocused && typeof lastFocused.focus === 'function') {
              lastFocused.focus({ preventScroll: true })
            } else if (openBtn) {
              openBtn.focus({ preventScroll: true })
            }
          } catch (error) {
            console.error('Failed to close product lightbox', error)
            isLightboxOpen = false
            clearStaleScrollLocks()
          }
        }

        const stepLightbox = (delta) => {
          if (!thumbs.length) return

          activeIndex = (activeIndex + delta + thumbs.length) % thumbs.length
          applyThumb(thumbs[activeIndex], { syncLightbox: true })
        }

        thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => {
            applyThumb(thumb)
          })
        })

        if (openBtn) {
          openBtn.addEventListener('click', () => {
            openLightboxView()
          })
        }

        if (closeBtn) {
          closeBtn.addEventListener('click', () => {
            closeLightboxView()
          })
        }

        if (prevBtn) {
          prevBtn.addEventListener('click', () => {
            stepLightbox(-1)
          })
        }

        if (nextBtn) {
          nextBtn.addEventListener('click', () => {
            stepLightbox(1)
          })
        }

        if (lightbox) {
          lightbox.addEventListener('click', (event) => {
            if (event.target === lightbox) {
              closeLightboxView()
            }
          })
        }

        document.addEventListener('keydown', (event) => {
          if (!lightbox || lightbox.hidden) return

          if (event.key === 'Escape') {
            closeLightboxView()
          } else if (event.key === 'ArrowLeft') {
            stepLightbox(-1)
          } else if (event.key === 'ArrowRight') {
            stepLightbox(1)
          }
        })

        gallery._setHeroFromVariant = (payload) => {
          setHeroImage(heroImage, payload)
          setActiveThumb(thumbs, payload.imageId)

          const matchedIndex = thumbs.findIndex((thumb) => thumb.dataset.imageId === String(payload.imageId || ''))
          if (matchedIndex >= 0) {
            activeIndex = matchedIndex
          }
        }
      } catch (error) {
        console.error('Failed to bind product gallery', error)
      }
    }

    const initVariantSelect = () => {
      try {
        const form = document.querySelector('[data-product-form]')
        if (!form) return

        const select = document.querySelector('[data-product-variant-select]')
        const priceEl = document.querySelector('[data-product-price]')
        const availabilityEl = document.querySelector('.industrial-product__availability')
        const skuWrap = document.querySelector('.industrial-product__sku')
        const skuEl = document.querySelector('[data-product-sku]')
        const cartBtn = document.querySelector('[data-add-to-cart]')
        const buyNowBtn = document.querySelector('[data-buy-now]')
        const quoteEl = document.querySelector('[data-quote]')
        const groupBuyBtn = document.querySelector('[data-group-buy]')
        const gallery = document.querySelector('[data-product-gallery]')
        const statusEl = document.querySelector('[data-product-form-status]')
        const allowUnavailable =
          form.dataset.allowUnavailable === 'true' ||
          availabilityEl?.dataset.allowUnavailable === 'true'
        const rootPath = window.Shopify?.routes?.root || '/'
        const storePath = (path) => {
          const normalizedRoot = rootPath.endsWith('/') ? rootPath : `${rootPath}/`
          return `${normalizedRoot}${String(path).replace(/^\//, '')}`
        }
        const cartAddUrl = storePath('cart/add.js')
        const cartClearUrl = storePath('cart/clear.js')
        const cartUrl = storePath('cart')
        const checkoutUrl = storePath('checkout')

        const setStatus = (message, { success = false } = {}) => {
          if (!statusEl) return
          if (!message) {
            statusEl.textContent = ''
            statusEl.hidden = true
            statusEl.classList.remove('is-success')
            return
          }
          statusEl.textContent = message
          statusEl.hidden = false
          statusEl.classList.toggle('is-success', success)
        }

        const setPurchaseButtonsDisabled = (disabled) => {
          if (cartBtn) cartBtn.disabled = disabled
          if (buyNowBtn) buyNowBtn.disabled = disabled
        }

        const restorePurchaseButtons = () => {
          if (select) {
            syncVariant()
            return
          }
          setPurchaseButtonsDisabled(false)
        }

        const syncVariant = () => {
          if (!select) return
          const option = select.options[select.selectedIndex]
          if (!option) return

          const available = option.dataset.available === 'true'
          const price = option.dataset.price || ''
          const rawPrice = option.dataset.priceRaw !== undefined ? parseInt(option.dataset.priceRaw, 10) : null
          const quoteOnly = rawPrice === 0
          const sku = option.dataset.sku || ''
          const image = option.dataset.image || ''
          const imageSrcset = option.dataset.imageSrcset || ''
          const imageFull = option.dataset.imageFull || ''
          const imageId = option.dataset.imageId || ''
          const canPurchase = available || allowUnavailable

          // Price-0 variants are quote-only (highest priority): mark the form
          // so the inquiry button replaces every purchase CTA, and swap the
          // price for a placeholder.
          form.classList.toggle('is-quote-only', quoteOnly)
          if (priceEl) {
            priceEl.textContent = quoteOnly ? priceEl.dataset.quotePrice || '$?' : price
          }

          // Keep the inquiry link's sku in sync with the selected variant.
          if (quoteEl) {
            const quoteBase = quoteEl.dataset.quoteBase || quoteEl.getAttribute('href') || ''
            quoteEl.setAttribute(
              'href',
              sku
                ? `${quoteBase}${quoteBase.includes('?') ? '&' : '?'}sku=${encodeURIComponent(sku)}`.replace('?&', '?')
                : quoteBase
            )
          }

          // Quote-only variants never show the group-buy CTA either.
          if (quoteOnly && groupBuyBtn) {
            groupBuyBtn.hidden = true
            form.classList.remove('has-group-buy')
          }

          if (availabilityEl) {
            availabilityEl.textContent = canPurchase
              ? availabilityEl.dataset.labelAvailable || ''
              : availabilityEl.dataset.labelUnavailable || ''
          }

          if (skuWrap && skuEl) {
            if (sku) {
              skuEl.textContent = sku
              skuWrap.hidden = false
            } else {
              skuEl.textContent = ''
              skuWrap.hidden = true
            }
          }

          setPurchaseButtonsDisabled(!canPurchase || quoteOnly)

          if (image && gallery && typeof gallery._setHeroFromVariant === 'function') {
            gallery._setHeroFromVariant({
              src: image,
              srcset: imageSrcset,
              fullSrc: imageFull,
              imageId
            })
          }

          try {
            const url = new URL(window.location.href)
            url.searchParams.set('variant', option.value)
            window.history.replaceState({}, '', url.toString())
          } catch (error) {
            console.error('Failed to update variant URL', error)
          }
        }

        const addToCartAndRedirect = async (triggerBtn, redirectUrl, { clearCartFirst = false } = {}) => {
          if (!triggerBtn || triggerBtn.disabled) return

          const defaultLabel = triggerBtn.dataset.labelDefault || triggerBtn.textContent
          const loadingLabel = triggerBtn.dataset.labelLoading || defaultLabel
          const genericError = triggerBtn.dataset.errorGeneric || 'Could not add this product to cart.'
          const soldOutError = triggerBtn.dataset.errorSoldout || genericError

          setStatus('')
          setPurchaseButtonsDisabled(true)
          triggerBtn.textContent = loadingLabel

          try {
            if (clearCartFirst) {
              try {
                await fetch(cartClearUrl, {
                  method: 'POST',
                  headers: { Accept: 'application/json' },
                  credentials: 'same-origin'
                })
              } catch (clearError) {
                console.error('Failed to clear cart before buy now', clearError)
              }
            }

            const formData = new FormData(form)
            const response = await fetch(cartAddUrl, {
              method: 'POST',
              headers: {
                Accept: 'application/json'
              },
              body: formData,
              credentials: 'same-origin'
            })

            let payload = null
            try {
              payload = await response.json()
            } catch (parseError) {
              payload = null
            }

            if (!response.ok) {
              const message = payload?.description || payload?.message || ''
              const isSoldOut = /sold out|inventory|unavailable|不能|缺货|库存|rupture|สต็อก/i.test(String(message))
              setStatus(isSoldOut ? soldOutError : (message || genericError))
              return
            }

            setStatus('', { success: true })
            window.location.href = redirectUrl
          } catch (error) {
            console.error('Failed to add product to cart', error)
            setStatus(genericError)
          } finally {
            triggerBtn.textContent = defaultLabel
            restorePurchaseButtons()
          }
        }

        const initCartSubmit = () => {
          form.addEventListener('submit', async (event) => {
            event.preventDefault()
            await addToCartAndRedirect(cartBtn, cartUrl)
          })

          if (buyNowBtn) {
            buyNowBtn.addEventListener('click', async () => {
              await addToCartAndRedirect(buyNowBtn, checkoutUrl, { clearCartFirst: true })
            })
          }
        }

        if (select) {
          select.addEventListener('change', syncVariant)
          syncVariant()
        }

        initCartSubmit()
      } catch (error) {
        console.error('Failed to bind product variant selector', error)
      }
    }

    const initGroupBuy = () => {
      try {
        const form = document.querySelector('[data-product-form]')
        const btn = document.querySelector('[data-group-buy]')
        if (!form || !btn) return

        // The Farabiulder Group Buy app runs in modal mode: it renders a
        // #gb-modal-trigger-{section} button that it shows (display:block,
        // enabled) only while an active campaign exists for the selected
        // variant. Our 团购 CTA mirrors that state and opens the app's modal.
        const block = document.querySelector('.group-buying-block')
        const trigger = block ? block.querySelector('[id^="gb-modal-trigger-"]') : null
        const sectionId = block ? block.dataset.sectionId : null

        const isActiveGroupBuy = () => {
          if (!trigger) return false
          if (trigger.style.display === 'none') return false
          if (trigger.disabled) return false
          // Require the app to have confirmed an active campaign (its async
          // /campaign-status check populates the config).
          const config = sectionId ? (window.groupBuyingConfig || {})[sectionId] : null
          if (!config || !config.campaignId || config.campaignStatus !== 'active') return false
          return true
        }

        // The app reports its campaign verdict in two places: active campaigns
        // populate window.groupBuyingConfig[sectionId] with campaignId /
        // campaignStatus, while a product with NO campaign only records
        // _noCampaignReason on the widget instance (window.gbInstances). We
        // must treat both as "decided", otherwise a tagged product without a
        // campaign would show the CTA forever.
        const isCampaignDecided = () => {
          const config = sectionId ? (window.groupBuyingConfig || {})[sectionId] : null
          if (config && ('campaignId' in config || 'campaignStatus' in config)) return true
          const instance = sectionId ? (window.gbInstances || {})[sectionId] : null
          return !!(
            instance &&
            (instance._noCampaignReason || instance.campaignId || instance.campaignStatus)
          )
        }

        const syncGroupBuy = () => {
          // Price-0 (quote-only) variants never run the group-buy flow — the
          // inquiry button takes over. This is the highest-priority rule.
          if (form.classList.contains('is-quote-only')) {
            btn.hidden = true
            form.classList.remove('has-group-buy')
            return
          }

          // Tagged products show the CTA immediately; untagged products wait
          // for the verdict. Once the verdict lands (active campaign -> trigger
          // shown, no/inactive campaign -> trigger stays hidden) we mirror the
          // trigger's real state for every product, so the tag never affects
          // the final display.
          const immediate = btn.dataset.groupBuyImmediate === '1'
          const show = isCampaignDecided() ? isActiveGroupBuy() : immediate
          form.classList.toggle('has-group-buy', show)
          btn.hidden = !show
        }

        if (trigger && typeof MutationObserver !== 'undefined') {
          const observer = new MutationObserver(syncGroupBuy)
          observer.observe(trigger, {
            attributes: true,
            attributeFilter: ['style', 'class', 'disabled']
          })
        }

        // Re-evaluate when the selected variant changes into or out of a
        // price-0 (quote-only) variant so the group-buy CTA comes back once a
        // priced variant is chosen again.
        const variantSelect = document.querySelector('[data-product-variant-select]')
        if (variantSelect) {
          variantSelect.addEventListener('change', () => {
            window.setTimeout(syncGroupBuy, 0)
          })
        }

        btn.addEventListener('click', () => {
          // Open the app's modal through its own trigger so all its listeners
          // run; fall back to calling openModal() on the modal instance.
          if (trigger && !trigger.disabled && typeof trigger.click === 'function') {
            trigger.click()
          } else if (sectionId && window.gbModalInstances && window.gbModalInstances[sectionId]) {
            const modal = window.gbModalInstances[sectionId]
            if (modal && typeof modal.openModal === 'function') {
              modal.openModal()
            }
          }
        })

        // Initial state.
        syncGroupBuy()

        // The app's verdict arrives asynchronously: it fetches /campaign-status
        // and then populates window.groupBuyingConfig[sectionId]. Keep polling
        // the config (up to ~15s) so the CTA appears the moment the app
        // responds, instead of relying on fixed-timeout re-checks that can
        // miss a slow /campaign-status round-trip.
        let pollCount = 0
        const pollGroupBuy = () => {
          syncGroupBuy()
          if (!isCampaignDecided() && pollCount < 60) {
            pollCount += 1
            window.setTimeout(pollGroupBuy, 250)
          }
        }
        pollGroupBuy()
      } catch (error) {
        console.error('Failed to bind group-buy CTA', error)
      }
    }

    const initGroupBuyModalLoading = () => {
      try {
        const block = document.querySelector('.group-buying-block')
        const sectionId = block ? block.dataset.sectionId : null
        if (!sectionId) return

        const loadingClass = 'industrial-gb-loading'
        // All modal action buttons that trigger a network call / navigation:
        // create-section create + add-to-cart, group-card join + add-to-cart,
        // empty-state create + add-to-cart, and "Complete Checkout Now".
        const buttonSelector = [
          '.gb-btn-create',
          '.gb-btn-add-to-cart-create',
          '.gb-btn-add-to-cart',
          '.gb-group-card-button-full',
          '#gb-create-group-empty-' + sectionId,
          '#gb-modal-retry-checkout'
        ].join(', ')

        const clearLoading = () => {
          document.querySelectorAll('.' + loadingClass).forEach((btn) => {
            btn.classList.remove(loadingClass)
            btn.disabled = false
          })
        }

        // Cancel/close controls that abort the flow before any API call runs.
        const isCancelControl = (el) => {
          if (!el || !el.closest) return false
          return !!(
            el.closest('.gb-tips-cancel') ||
            el.closest('#gb-modal-cancel-modal') ||
            el.closest('.gb-login-cancel') ||
            el.closest('.gb-tips-modal .gb-modal-close') ||
            el.closest('.gb-tips-modal .gb-modal-backdrop')
          )
        }

        // Capture-phase listener runs before the app's own handlers, so the
        // spinner appears the instant either bottom button is clicked.
        document.addEventListener(
          'click',
          (event) => {
            const btn = event.target.closest(buttonSelector)
            if (btn && !btn.disabled && !btn.classList.contains(loadingClass)) {
              btn.classList.add(loadingClass)
              btn.disabled = true
              return
            }
            if (isCancelControl(event.target)) {
              clearLoading()
            }
          },
          true
        )

        // Clear the spinner when the main modal closes (style.display -> none).
        const overlay = document.getElementById('gb-modal-overlay-' + sectionId)
        if (overlay && typeof MutationObserver !== 'undefined') {
          const observer = new MutationObserver(() => {
            if (overlay.style.display === 'none') clearLoading()
          })
          observer.observe(overlay, { attributes: true, attributeFilter: ['style'] })
        }

        // Clear the spinner when the app ends a flow with a notification toast
        // (success or error) that does not navigate away from the page.
        if (typeof MutationObserver !== 'undefined') {
          const toastObserver = new MutationObserver((records) => {
            if (!document.querySelector('.' + loadingClass)) return
            records.forEach((record) => {
              record.addedNodes.forEach((node) => {
                if (
                  node.nodeType === 1 &&
                  node.classList &&
                  node.classList.contains('gb-notification-toast')
                ) {
                  clearLoading()
                }
              })
            })
          })
          toastObserver.observe(document.body, { childList: true })
        }
      } catch (error) {
        console.error('Failed to bind group-buy modal loading states', error)
      }
    }

    initGallery()
    initVariantSelect()
    initGroupBuy()
    initGroupBuyModalLoading()
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-wf-search-page]');
    if (!root) return;

    const input = root.querySelector('[data-wf-search-page-input]');
    const correction = root.querySelector('[data-wf-search-page-correction]');
    const hotTerms = (root.dataset.hotTerms || '').split(',').map((term) => term.trim()).filter(Boolean);
    const didYouMeanPrefix = root.dataset.didYouMean || '';

    const distance = (a, b) => {
      a = (a || '').toLowerCase().trim();
      b = (b || '').toLowerCase().trim();
      if (!a || !b) return 99;
      const matrix = Array.from({ length: b.length + 1 }, (_, i) => [i]);
      for (let j = 0; j <= a.length; j += 1) matrix[0][j] = j;
      for (let i = 1; i <= b.length; i += 1) {
        for (let j = 1; j <= a.length; j += 1) {
          matrix[i][j] = b[i - 1] === a[j - 1]
            ? matrix[i - 1][j - 1]
            : Math.min(matrix[i - 1][j - 1] + 1, matrix[i][j - 1] + 1, matrix[i - 1][j] + 1);
        }
      }
      return matrix[b.length][a.length];
    };

    const renderCorrection = () => {
      const query = input.value.trim();
      const match = hotTerms
        .map((term) => ({ term, score: distance(query, term) }))
        .filter((item) => item.score > 0 && item.score <= 3)
        .sort((a, b) => a.score - b.score)[0];

      if (!match || query.length < 3) {
        correction.hidden = true;
        correction.innerHTML = '';
        return;
      }

      const url = `/search?type=product&options%5Bprefix%5D=last&q=${encodeURIComponent(match.term)}`;
      correction.innerHTML = `${didYouMeanPrefix} <a href="${url}">${match.term}</a>?`;
      correction.hidden = false;
    };

    renderCorrection();
    input.addEventListener('input', renderCorrection);
  })();

  } catch(e) { console.error(e); }
})();
})();
